export const DATE_TIME_FORMAT = `D MMM YYYY, hh:mm A`;
export const DATE_FORMAT = `D MMM YYYY`;
export const DATE_FORMAT_CUSTOM = `YYYY-MM-DD`;
